import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// User data types
export interface ContextIdStateProps {
  contextId: string;
  isAudit: boolean;
  decisionData: any;
  isReadOnly: boolean;
  scriptName: string;
  queryObj: any;
  isGalleryPanelOpen: boolean;
  viewFlagged: boolean;
  loadedfirstTime: boolean;
  showSubmitDataError: boolean; // Added to match the original code context
}

// initial state of user's data
const initialState: ContextIdStateProps = {
  contextId: '',
  isAudit: true,
  decisionData: {},
  isReadOnly: false,
  scriptName: '',
  queryObj: {},
  isGalleryPanelOpen: false,
  viewFlagged: false,
  loadedfirstTime: false,
  showSubmitDataError: false, // Added to match the original code context
};

const contextIdSlice = createSlice({
  name: 'contextId',
  initialState,
  reducers: {
    setShowSubmitDataError: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.showSubmitDataError = action.payload;
    },

    setLoadedFirstTime: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.loadedfirstTime = action.payload;
    },
    resetContextId: (state: ContextIdStateProps) => {
      state.contextId = initialState.contextId;
    },
    setContextId: (
      state: ContextIdStateProps,
      action: PayloadAction<string>
    ) => {
      if (state.contextId !== action.payload) {
        state.loadedfirstTime = false;
      }
      state.contextId = action.payload;
    },

    resetAuditState: (state: ContextIdStateProps) => {
      state.isAudit = initialState.isAudit;
    },
    setAuditState: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.isAudit = action.payload;
    },

    resetViewFlagged: (state: ContextIdStateProps) => {
      state.viewFlagged = initialState.viewFlagged;
    },
    setViewFlagged: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.viewFlagged = action.payload;
    },

    resetIsGalleryPanelOpen: (state: ContextIdStateProps) => {
      state.isGalleryPanelOpen = initialState.isGalleryPanelOpen;
    },
    setIsGalleryPanelOpen: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.isGalleryPanelOpen = action.payload;
    },

    resetQueryObj: (state: ContextIdStateProps) => {
      state.queryObj = initialState.queryObj;
    },
    setQueryObj: (state: ContextIdStateProps, action) => {
      state.queryObj = action.payload;
    },

    resetDecisionData: (state: ContextIdStateProps) => {
      state.decisionData = initialState.decisionData;
    },
    setDecisionData: (state: ContextIdStateProps, action) => {
      state.decisionData = action.payload;
    },

    resetIsReadOnly: (state: ContextIdStateProps) => {
      state.isReadOnly = initialState.isReadOnly;
    },
    setIsReadOnly: (
      state: ContextIdStateProps,
      action: PayloadAction<boolean>
    ) => {
      state.isReadOnly = action.payload;
    },

    resetScriptName: (state: ContextIdStateProps) => {
      state.scriptName = initialState.scriptName;
    },
    setScriptName: (
      state: ContextIdStateProps,
      action: PayloadAction<string>
    ) => {
      state.scriptName = action.payload;
    },

    resetState: () => initialState,
  },
});

export const {
  resetContextId,
  setContextId,
  resetAuditState,
  setAuditState,
  resetViewFlagged,
  setViewFlagged,
  resetIsGalleryPanelOpen,
  setIsGalleryPanelOpen,
  setQueryObj,
  resetQueryObj,
  resetDecisionData,
  setDecisionData,
  resetIsReadOnly,
  setIsReadOnly,
  resetScriptName,
  setScriptName,
  resetState,
  setLoadedFirstTime,
  setShowSubmitDataError,
} = contextIdSlice.actions;
export default contextIdSlice.reducer;
